"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

require("core-js/modules/es.array.reduce.js");

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withoutBreadcrumbFinalTrail = exports.withBreadcrumbFinalTrail = exports.withoutBreadcrumbStartingTrail = exports.withBreadcrumbStartingTrail = exports.Breadcrumbs = exports.BreadcrumbsClean = void 0;

var react_1 = __importDefault(require("react"));

var core_1 = require("@bodiless/core");

var fclasses_1 = require("@bodiless/fclasses");

var mobx_react_lite_1 = require("mobx-react-lite");

var lodash_1 = require("lodash");

var BreadcrumbStoreProvider_1 = require("./BreadcrumbStoreProvider");
/**
 * removes first item from the trail
 * when there is a custom starting trail and
 * when the first store item has frontpage path
 *
 * @param items - breadcrumb store items
 * @param props - breadcrumb component props
 *
 * @returns uuids - a list of item uuids
 */


var firstItemHomeLinkReducer = function firstItemHomeLinkReducer(items, _a) {
  var hasStartingTrail = _a.hasStartingTrail;
  return items.filter(function (item) {
    return !(hasStartingTrail && item.isFirst() && item.hasPath('/'));
  }).map(function (item) {
    return item.uuid;
  });
};

var BreadcrumbsClean$ = function BreadcrumbsClean$(props) {
  var _a = props.hasStartingTrail,
      hasStartingTrail = _a === void 0 ? false : _a,
      components = props.components,
      _b = props.items,
      items = _b === void 0 ? [] : _b,
      _c = props.hasFinalTrail,
      hasFinalTrail = _c === void 0 ? false : _c,
      _d = props.renderLastItemWithoutLink,
      renderLastItemWithoutLink = _d === void 0 ? false : _d;
  var hasStartingTrail$ = typeof hasStartingTrail === 'function' ? hasStartingTrail() : hasStartingTrail;
  var hasFinalTrail$ = typeof hasFinalTrail === 'function' ? hasFinalTrail() : hasFinalTrail;
  var renderLastItemWithoutLink$ = typeof renderLastItemWithoutLink === 'function' ? renderLastItemWithoutLink() : renderLastItemWithoutLink;
  var StartingTrail = components.StartingTrail,
      Separator = components.Separator,
      BreadcrumbWrapper = components.BreadcrumbWrapper,
      BreadcrumbItem = components.BreadcrumbItem,
      BreadcrumbLink = components.BreadcrumbLink,
      BreadcrumbTitle = components.BreadcrumbTitle,
      FinalTrail = components.FinalTrail;
  var items$ = items.map(function (item, index) {
    var isLastItem = index === items.length - 1;
    var position = item.position,
        isCurrentPage = item.isCurrentPage; // increment position by 1 if there is starting trail item

    var position$ = hasStartingTrail$ ? position + 1 : position;

    if (isLastItem && renderLastItemWithoutLink$) {
      return react_1.default.createElement(react_1.default.Fragment, {
        key: item.uuid
      }, react_1.default.createElement(BreadcrumbItem, {
        position: position$,
        isCurrentPage: isCurrentPage
      }, react_1.default.createElement(BreadcrumbTitle, {
        nodeKey: item.title.nodeKey,
        nodeCollection: item.title.nodeCollection
      })));
    }

    return react_1.default.createElement(react_1.default.Fragment, {
      key: item.uuid
    }, react_1.default.createElement(BreadcrumbItem, {
      position: position$,
      isCurrentPage: isCurrentPage
    }, react_1.default.createElement(BreadcrumbLink, {
      nodeKey: item.link.nodeKey,
      nodeCollection: item.link.nodeCollection
    }, react_1.default.createElement(BreadcrumbTitle, {
      nodeKey: item.title.nodeKey,
      nodeCollection: item.title.nodeCollection
    }))), !isLastItem && react_1.default.createElement(Separator, {
      key: "separator" + item.uuid
    }));
  });
  var finalTrailItemPosition = (hasStartingTrail$ ? 1 : 0) + items$.length + 1;
  return react_1.default.createElement(BreadcrumbWrapper, null, hasStartingTrail$ && react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(BreadcrumbItem, {
    position: 1,
    isCurrentPage: false,
    key: "startingTrail"
  }, react_1.default.createElement(StartingTrail, null)), (items$.length > 0 || hasFinalTrail$) && react_1.default.createElement(Separator, {
    key: "startingTrailSeparator"
  })), items$, hasFinalTrail$ && react_1.default.createElement(react_1.default.Fragment, null, items$.length > 0 && react_1.default.createElement(Separator, {
    key: "finalTrailSeparator"
  }), react_1.default.createElement(BreadcrumbItem, {
    key: "finalTrail",
    position: finalTrailItemPosition,
    isCurrentPage: false
  }, react_1.default.createElement(FinalTrail, null))));
};

var BreadcrumbStartComponents = {
  StartingTrail: fclasses_1.asComponent('span'),
  Separator: fclasses_1.asComponent('span'),
  BreadcrumbWrapper: fclasses_1.asComponent('ul'),
  BreadcrumbItem: lodash_1.flowRight(core_1.withoutProps(['position', 'isCurrentPage']), fclasses_1.asComponent)('li'),
  BreadcrumbLink: fclasses_1.asComponent('a'),
  BreadcrumbTitle: fclasses_1.asComponent('span'),
  FinalTrail: fclasses_1.asComponent('span')
};
/**
 * Clean component that renders breadcrumbs.
 * @see BreadcrumbsComponents for a list of design components.
 */

var BreadcrumbsClean = fclasses_1.designable(BreadcrumbStartComponents, 'Breadcrumbs')(BreadcrumbsClean$);
exports.BreadcrumbsClean = BreadcrumbsClean;
/**
 * HOC that populates a breadcrumb based component with data from breadcrumb store.
 * @param Component a breadcrumb based component
 */
// eslint-disable-next-line max-len

var withBreadcrumbItemsFromStore = function withBreadcrumbItemsFromStore(Component) {
  var WithBreadcrumbItemsFromStore = function WithBreadcrumbItemsFromStore(props) {
    var nodeCollection = props.nodeCollection,
        _a = props.hasStartingTrail,
        hasStartingTrail = _a === void 0 ? false : _a,
        _b = props.hasFinalTrail,
        hasFinalTrail = _b === void 0 ? false : _b,
        _c = props.itemsReducer,
        itemsReducer = _c === void 0 ? firstItemHomeLinkReducer : _c,
        _d = props.renderLastItemWithoutLink,
        renderLastItemWithoutLink = _d === void 0 ? true : _d,
        rest = __rest(props, ["nodeCollection", "hasStartingTrail", "hasFinalTrail", "itemsReducer", "renderLastItemWithoutLink"]);

    var store = BreadcrumbStoreProvider_1.useBreadcrumbStore();
    if (store === undefined) return react_1.default.createElement(Component, __assign({}, props));
    var node = core_1.useNode(nodeCollection).node;
    var basePath = node.path;
    var items = itemsReducer(store.breadcrumbTrail, {
      hasStartingTrail: hasStartingTrail,
      hasFinalTrail: hasFinalTrail
    }).map(function (uuid) {
      return store.getItem(uuid);
    }) // map items retrieved from store
    // into items expected by base breadcrumb component

    /* eslint-disable @typescript-eslint/indent */
    // eslint throws an indentation error for lines inside reduce body
    // automatic eslint fix brings code to unreadable state
    // probably that is an eslint plugin issue
    // the disabled rule is enabled back after reduce
    .reduce(function (prev, current, index) {
      if (current === undefined) return prev;
      var linkNodePath = current.link.nodePath.replace(basePath + "$", '');
      var titleNodePath = current.title.nodePath.replace(basePath + "$", '');
      prev.push({
        uuid: current.uuid,
        link: {
          nodeKey: linkNodePath,
          nodeCollection: nodeCollection
        },
        title: {
          nodeKey: titleNodePath,
          nodeCollection: nodeCollection
        },
        position: index + 1,
        isCurrentPage: current.isLast() && store.hasCurrentPageItem()
      });
      return prev;
    }, []);
    /* eslint-enable @typescript-eslint/indent */

    var hasFinalTrail$0 = typeof hasFinalTrail === 'function' ? hasFinalTrail() : hasFinalTrail;
    var hasFinalTrail$1 = hasFinalTrail$0 && !store.hasCurrentPageItem();
    var lastItemWithoutLink = typeof renderLastItemWithoutLink === 'function' ? renderLastItemWithoutLink() : renderLastItemWithoutLink;

    var props$1 = __assign(__assign({}, rest), {
      items: items,
      hasFinalTrail: hasFinalTrail$1,
      hasStartingTrail: hasStartingTrail,
      renderLastItemWithoutLink: lastItemWithoutLink && !hasFinalTrail$1 && store.hasCurrentPageItem()
    });

    return react_1.default.createElement(Component, __assign({}, props$1));
  };

  return WithBreadcrumbItemsFromStore;
};
/**
 * HOC that enables rendering of starting trail for a breadcrumb based component.
 * @param Component a breadcrumb based component
 */


var withStartingTrail = fclasses_1.addProps({
  hasStartingTrail: true
});
exports.withBreadcrumbStartingTrail = withStartingTrail;
/**
 * HOC that disables rendering of starting trail for a breadcrumb based component.
 * @param Component a breadcrumb based component
 */

var withoutStartingTrail = fclasses_1.addProps({
  hasStartingTrail: false
});
exports.withoutBreadcrumbStartingTrail = withoutStartingTrail;
/**
 * HOC that enables rendering of final trail for a breadcrumb based component.
 * @param Component a breadcrumb based component
 */

var withFinalTrail = fclasses_1.addProps({
  hasFinalTrail: true
});
exports.withBreadcrumbFinalTrail = withFinalTrail;
/**
 * HOC that disables rendering of final trail for a breadcrumb based component.
 * @param Component a breadcrumb based component
 */

var withoutFinalTrail = fclasses_1.addProps({
  hasFinalTrail: false
});
exports.withoutBreadcrumbFinalTrail = withoutFinalTrail;
/**
 * Component that renders breadcrumb items retrieved from breadcrumb store.
 */

var Breadcrumbs = lodash_1.flowRight(mobx_react_lite_1.observer, withBreadcrumbItemsFromStore)(BreadcrumbsClean);
exports.Breadcrumbs = Breadcrumbs;